var _clipPath, _clipPath2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _filter, _mask, _filter2, _mask2, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaurel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    width: 430,
    height: 430,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 430,
    x: 0,
    y: 0
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L430,0 L430,430 L0,430z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "__lottie_element_16"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-22.9998779296875,-35.000091552734375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,150.83299255371094,351.20001220703125)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,199,56)",
    fillOpacity: 1,
    d: " M29.389999389648438,-0.14000000059604645 C24.43000030517578,7.71999979019165 13.180000305175781,13.239999771118164 0.05999999865889549,13.300000190734863 C-13.050000190734863,13.359999656677246 -24.360000610351562,7.949999809265137 -29.389999389648438,0.14000000059604645 C-24.43000030517578,-7.71999979019165 -13.180000305175781,-13.229999542236328 -0.05999999865889549,-13.300000190734863 C6.269999980926514,-13.329999923706055 12.180000305175781,-12.079999923706055 17.15999984741211,-9.90999984741211"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,118.46299743652344,304.2799987792969)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,199,56)",
    fillOpacity: 1,
    d: " M27.93000030517578,9.130000114440918 C20.760000228881836,15.029999732971191 8.34000015258789,16.719999313354492 -4.130000114440918,12.640000343322754 C-16.600000381469727,8.5600004196167 -25.6200008392334,-0.14000000059604645 -27.93000030517578,-9.140000343322754 C-20.75,-15.029999732971191 -8.329999923706055,-16.719999313354492 4.139999866485596,-12.640000343322754 C12.640000343322754,-9.859999656677246 19.540000915527344,-4.929999828338623 23.799999237060547,0.7799999713897705"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,113.46697235107422,245.40501403808594)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,199,56)",
    fillOpacity: 1,
    d: " M18.535999298095703,23.315000534057617 C18.525999069213867,23.325000762939453 18.525999069213867,23.325000762939453 18.525999069213867,23.334999084472656 C9.276000022888184,24.135000228881836 -1.9240000247955322,18.4950008392334 -9.894000053405762,8.085000038146973 C-17.86400032043457,-2.3350000381469727 -20.384000778198242,-14.614999771118164 -17.194000244140625,-23.334999084472656 C-7.943999767303467,-24.135000228881836 3.25600004196167,-18.4950008392334 11.22599983215332,-8.085000038146973 C13.656000137329102,-4.90500020980835 15.586000442504883,-1.5449999570846558 16.986000061035156,1.8250000476837158"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,134.96397399902344,175.51499938964844)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,199,56)",
    fillOpacity: 1,
    d: " M13.420000076293945,8.3149995803833 C13.710000038146973,5.09499979019165 13.649999618530273,1.6950000524520874 13.180000305175781,-1.774999976158142 C11.430000305175781,-14.774999618530273 4.510000228881836,-25.225000381469727 -3.9200000762939453,-29.125 C-11.020000457763672,-23.135000228881836 -14.930000305175781,-11.225000381469727 -13.180000305175781,1.774999976158142 C-11.430000305175781,14.765000343322754 -4.510000228881836,25.225000381469727 3.9200000762939453,29.125"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.9999997615814209,-0.0006909345975145698,0.0006909345975145698,0.9999997615814209,202.82118225097656,116.03379821777344)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,199,56)",
    fillOpacity: 1,
    d: " M8.909000396728516,9.890999794006348 C-0.8349999785423279,18.670000076293945 -12.890000343322754,22.136999130249023 -21.840999603271484,19.656999588012695 C-23.378000259399414,10.496000289916992 -18.63800048828125,-1.090999960899353 -8.894000053405762,-9.869999885559082 C0.8500000238418579,-18.64900016784668 12.888999938964844,-22.139999389648438 21.84000015258789,-19.65999984741211 C23.37700080871582,-10.49899959564209 18.652999877929688,1.1119999885559082 8.909000396728516,9.890999794006348z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "__lottie_element_28"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,475.08587646484375,-35.000091552734375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,206.21299743652344,335.4960021972656)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,199,56)",
    fillOpacity: 1,
    d: " M13.253000259399414,-1.1019999980926514 C14.34000015258789,11.968999862670898 9.829000473022461,23.663999557495117 2.434999942779541,29.285999298095703 C-5.785999774932861,24.961999893188477 -12.166000366210938,14.17300033569336 -13.253000259399414,1.1019999980926514 C-14.34000015258789,-11.968999862670898 -9.829000473022461,-23.663999557495117 -2.434999942779541,-29.285999298095703 C5.785999774932861,-24.961999893188477 12.166000366210938,-14.17300033569336 13.253000259399414,-1.1019999980926514z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,165.58200073242188,300.0989990234375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,199,56)",
    fillOpacity: 1,
    d: " M12.527999877929688,4.4629998207092285 C8.126999855041504,16.81800079345703 -0.8069999814033508,25.610000610351562 -9.862000465393066,27.68199920654297 C-15.567000389099121,20.351999282836914 -16.929000854492188,7.892000198364258 -12.527999877929688,-4.4629998207092285 C-8.12600040435791,-16.81800079345703 0.8069999814033508,-25.610000610351562 9.862000465393066,-27.68199920654297 C15.567000389099121,-20.351999282836914 16.93000030517578,-7.892000198364258 12.527999877929688,4.4629998207092285z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,150.44900512695312,239.9010009765625)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,199,56)",
    fillOpacity: 1,
    d: " M-19.215999603271484,22.339000701904297 C-10.026000022888184,23.638999938964844 1.4539999961853027,18.608999252319336 9.973999977111816,8.638999938964844 C18.493999481201172,-1.3309999704360962 21.673999786376953,-13.451000213623047 18.964000701904297,-22.340999603271484 C9.763999938964844,-23.631000518798828 -1.715999960899353,-18.611000061035156 -10.246000289916992,-8.640999794006348 C-15.736000061035156,-2.2109999656677246 -19.016000747680664,5.109000205993652 -19.9060001373291,11.888999938964844"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.9999999403953552,0.0002938330580946058,-0.0002938330580946058,0.9999999403953552,172.99168395996094,174.19993591308594)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,199,56)",
    fillOpacity: 1,
    d: " M-16.339866638183594,-4.757514476776123 C-13.409866333007812,-7.467514514923096 -9.895000457763672,-9.92199993133545 -5.934999942779541,-11.902000427246094 C5.804999828338623,-17.75200080871582 18.344999313354492,-17.892000198364258 26.30500030517578,-13.112000465393066 C25.325000762939453,-3.871999979019165 17.674999237060547,6.047999858856201 5.934999942779541,11.89799976348877 C-5.804999828338623,17.74799919128418 -18.344999313354492,17.898000717163086 -26.30500030517578,13.107999801635742 C-26.295000076293945,13.027999877929688 -26.28499984741211,12.947999954223633 -26.274999618530273,12.868000030517578"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.9999997615814209,-0.0006909345975145698,0.0006909345975145698,0.9999997615814209,202.82118225097656,116.03379821777344)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,199,56)",
    fillOpacity: 1,
    d: " M8.909000396728516,9.890999794006348 C-0.8349999785423279,18.670000076293945 -12.890000343322754,22.136999130249023 -21.840999603271484,19.656999588012695 C-23.378000259399414,10.496000289916992 -18.63800048828125,-1.090999960899353 -8.894000053405762,-9.869999885559082 C0.8500000238418579,-18.64900016784668 12.888999938964844,-22.139999389648438 21.84000015258789,-19.65999984741211 C23.37700080871582,-10.49899959564209 18.652999877929688,1.1119999885559082 8.909000396728516,9.890999794006348z"
  }))))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "__lottie_element_40",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "1.0 0.0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_28_2",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#__lottie_element_40)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 430,
    x: 0,
    y: 0,
    fill: "#ffffff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#__lottie_element_28"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "__lottie_element_41",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "1.0 0.0"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_16_2",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#__lottie_element_41)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 430,
    x: 0,
    y: 0,
    fill: "#ffffff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#__lottie_element_16"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_5)",
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-34.9998779296875,-35.000091552734375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,206.21299743652344,335.4960021972656)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M13.253000259399414,-1.1019999980926514 C14.34000015258789,11.968999862670898 9.829000473022461,23.663999557495117 2.434999942779541,29.285999298095703 C-5.785999774932861,24.961999893188477 -12.166000366210938,14.17300033569336 -13.253000259399414,1.1019999980926514 C-14.34000015258789,-11.968999862670898 -9.829000473022461,-23.663999557495117 -2.434999942779541,-29.285999298095703 C5.785999774932861,-24.961999893188477 12.166000366210938,-14.17300033569336 13.253000259399414,-1.1019999980926514z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,150.83299255371094,351.20001220703125)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M29.389999389648438,-0.14000000059604645 C24.43000030517578,7.71999979019165 13.180000305175781,13.239999771118164 0.05999999865889549,13.300000190734863 C-13.050000190734863,13.359999656677246 -24.360000610351562,7.949999809265137 -29.389999389648438,0.14000000059604645 C-24.43000030517578,-7.71999979019165 -13.180000305175781,-13.229999542236328 -0.05999999865889549,-13.300000190734863 C6.269999980926514,-13.329999923706055 12.180000305175781,-12.079999923706055 17.15999984741211,-9.90999984741211"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,165.58200073242188,300.0989990234375)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M12.527999877929688,4.4629998207092285 C8.126999855041504,16.81800079345703 -0.8069999814033508,25.610000610351562 -9.862000465393066,27.68199920654297 C-15.567000389099121,20.351999282836914 -16.929000854492188,7.892000198364258 -12.527999877929688,-4.4629998207092285 C-8.12600040435791,-16.81800079345703 0.8069999814033508,-25.610000610351562 9.862000465393066,-27.68199920654297 C15.567000389099121,-20.351999282836914 16.93000030517578,-7.892000198364258 12.527999877929688,4.4629998207092285z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,118.46299743652344,304.2799987792969)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M27.93000030517578,9.130000114440918 C20.760000228881836,15.029999732971191 8.34000015258789,16.719999313354492 -4.130000114440918,12.640000343322754 C-16.600000381469727,8.5600004196167 -25.6200008392334,-0.14000000059604645 -27.93000030517578,-9.140000343322754 C-20.75,-15.029999732971191 -8.329999923706055,-16.719999313354492 4.139999866485596,-12.640000343322754 C12.640000343322754,-9.859999656677246 19.540000915527344,-4.929999828338623 23.799999237060547,0.7799999713897705"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,150.44900512695312,239.9010009765625)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M-19.215999603271484,22.339000701904297 C-10.026000022888184,23.638999938964844 1.4539999961853027,18.608999252319336 9.973999977111816,8.638999938964844 C18.493999481201172,-1.3309999704360962 21.673999786376953,-13.451000213623047 18.964000701904297,-22.340999603271484 C9.763999938964844,-23.631000518798828 -1.715999960899353,-18.611000061035156 -10.246000289916992,-8.640999794006348 C-15.736000061035156,-2.2109999656677246 -19.016000747680664,5.109000205993652 -19.9060001373291,11.888999938964844"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,113.46697235107422,245.40501403808594)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M18.535999298095703,23.315000534057617 C18.525999069213867,23.325000762939453 18.525999069213867,23.325000762939453 18.525999069213867,23.334999084472656 C9.276000022888184,24.135000228881836 -1.9240000247955322,18.4950008392334 -9.894000053405762,8.085000038146973 C-17.86400032043457,-2.3350000381469727 -20.384000778198242,-14.614999771118164 -17.194000244140625,-23.334999084472656 C-7.943999767303467,-24.135000228881836 3.25600004196167,-18.4950008392334 11.22599983215332,-8.085000038146973 C13.656000137329102,-4.90500020980835 15.586000442504883,-1.5449999570846558 16.986000061035156,1.8250000476837158"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,134.96397399902344,175.51499938964844)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M13.420000076293945,8.3149995803833 C13.710000038146973,5.09499979019165 13.649999618530273,1.6950000524520874 13.180000305175781,-1.774999976158142 C11.430000305175781,-14.774999618530273 4.510000228881836,-25.225000381469727 -3.9200000762939453,-29.125 C-11.020000457763672,-23.135000228881836 -14.930000305175781,-11.225000381469727 -13.180000305175781,1.774999976158142 C-11.430000305175781,14.765000343322754 -4.510000228881836,25.225000381469727 3.9200000762939453,29.125"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.9999999403953552,0.0002938330580946058,-0.0002938330580946058,0.9999999403953552,172.99168395996094,174.19993591308594)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M-16.339866638183594,-4.757514476776123 C-13.409866333007812,-7.467514514923096 -9.895000457763672,-9.92199993133545 -5.934999942779541,-11.902000427246094 C5.804999828338623,-17.75200080871582 18.344999313354492,-17.892000198364258 26.30500030517578,-13.112000465393066 C25.325000762939453,-3.871999979019165 17.674999237060547,6.047999858856201 5.934999942779541,11.89799976348877 C-5.804999828338623,17.74799919128418 -18.344999313354492,17.898000717163086 -26.30500030517578,13.107999801635742 C-26.295000076293945,13.027999877929688 -26.28499984741211,12.947999954223633 -26.274999618530273,12.868000030517578"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.9999997615814209,-0.0006909345975145698,0.0006909345975145698,0.9999997615814209,202.82118225097656,116.03379821777344)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M8.909000396728516,9.890999794006348 C-0.8349999785423279,18.670000076293945 -12.890000343322754,22.136999130249023 -21.840999603271484,19.656999588012695 C-23.378000259399414,10.496000289916992 -18.63800048828125,-1.090999960899353 -8.894000053405762,-9.869999885559082 C0.8500000238418579,-18.64900016784668 12.888999938964844,-22.139999389648438 21.84000015258789,-19.65999984741211 C23.37700080871582,-10.49899959564209 18.652999877929688,1.1119999885559082 8.909000396728516,9.890999794006348z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_16_2)",
    style: {
      mixBlendMode: "multiply",
      display: "block"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-34.9998779296875,-35.000091552734375)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,150.83299255371094,351.20001220703125)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M29.389999389648438,-0.14000000059604645 C24.43000030517578,7.71999979019165 13.180000305175781,13.239999771118164 0.05999999865889549,13.300000190734863 C-13.050000190734863,13.359999656677246 -24.360000610351562,7.949999809265137 -29.389999389648438,0.14000000059604645 C-24.43000030517578,-7.71999979019165 -13.180000305175781,-13.229999542236328 -0.05999999865889549,-13.300000190734863 C6.269999980926514,-13.329999923706055 12.180000305175781,-12.079999923706055 17.15999984741211,-9.90999984741211"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,118.46299743652344,304.2799987792969)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M27.93000030517578,9.130000114440918 C20.760000228881836,15.029999732971191 8.34000015258789,16.719999313354492 -4.130000114440918,12.640000343322754 C-16.600000381469727,8.5600004196167 -25.6200008392334,-0.14000000059604645 -27.93000030517578,-9.140000343322754 C-20.75,-15.029999732971191 -8.329999923706055,-16.719999313354492 4.139999866485596,-12.640000343322754 C12.640000343322754,-9.859999656677246 19.540000915527344,-4.929999828338623 23.799999237060547,0.7799999713897705"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,113.46697235107422,245.40501403808594)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M18.535999298095703,23.315000534057617 C18.525999069213867,23.325000762939453 18.525999069213867,23.325000762939453 18.525999069213867,23.334999084472656 C9.276000022888184,24.135000228881836 -1.9240000247955322,18.4950008392334 -9.894000053405762,8.085000038146973 C-17.86400032043457,-2.3350000381469727 -20.384000778198242,-14.614999771118164 -17.194000244140625,-23.334999084472656 C-7.943999767303467,-24.135000228881836 3.25600004196167,-18.4950008392334 11.22599983215332,-8.085000038146973 C13.656000137329102,-4.90500020980835 15.586000442504883,-1.5449999570846558 16.986000061035156,1.8250000476837158"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,134.96397399902344,175.51499938964844)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M13.420000076293945,8.3149995803833 C13.710000038146973,5.09499979019165 13.649999618530273,1.6950000524520874 13.180000305175781,-1.774999976158142 C11.430000305175781,-14.774999618530273 4.510000228881836,-25.225000381469727 -3.9200000762939453,-29.125 C-11.020000457763672,-23.135000228881836 -14.930000305175781,-11.225000381469727 -13.180000305175781,1.774999976158142 C-11.430000305175781,14.765000343322754 -4.510000228881836,25.225000381469727 3.9200000762939453,29.125"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.9999997615814209,-0.0006909345975145698,0.0006909345975145698,0.9999997615814209,202.82118225097656,116.03379821777344)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M8.909000396728516,9.890999794006348 C-0.8349999785423279,18.670000076293945 -12.890000343322754,22.136999130249023 -21.840999603271484,19.656999588012695 C-23.378000259399414,10.496000289916992 -18.63800048828125,-1.090999960899353 -8.894000053405762,-9.869999885559082 C0.8500000238418579,-18.64900016784668 12.888999938964844,-22.139999389648438 21.84000015258789,-19.65999984741211 C23.37700080871582,-10.49899959564209 18.652999877929688,1.1119999885559082 8.909000396728516,9.890999794006348z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-34.9998779296875,-35.000091552734375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,210.9980010986328,272.9150085449219)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    className: "primary",
    stroke: "rgb(255,198,56)",
    strokeOpacity: 1,
    strokeWidth: 7,
    d: " M-30.0049991607666,-137.2050018310547 C-50.064998626708984,-112.88500213623047 -80.55500030517578,-69.00499725341797 -80.55500030517578,-26.924999237060547 C-80.55500030517578,40.185001373291016 -42.345001220703125,84.23500061035156 8.654999732971191,94.74500274658203 C11.336000442504883,95.2969970703125 13.991000175476074,95.94499969482422 16.614999771118164,96.68499755859375 M53.249000549316406,114.58799743652344 C55.20899963378906,116.02899932861328 57.125,117.53600311279297 58.994998931884766,119.1050033569336 C58.994998931884766,119.1050033569336 80.55500030517578,137.2050018310547 80.55500030517578,137.2050018310547"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,465.08587646484375,-35.000091552734375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,206.21299743652344,335.4960021972656)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M13.253000259399414,-1.1019999980926514 C14.34000015258789,11.968999862670898 9.829000473022461,23.663999557495117 2.434999942779541,29.285999298095703 C-5.785999774932861,24.961999893188477 -12.166000366210938,14.17300033569336 -13.253000259399414,1.1019999980926514 C-14.34000015258789,-11.968999862670898 -9.829000473022461,-23.663999557495117 -2.434999942779541,-29.285999298095703 C5.785999774932861,-24.961999893188477 12.166000366210938,-14.17300033569336 13.253000259399414,-1.1019999980926514z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,150.83299255371094,351.20001220703125)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M29.389999389648438,-0.14000000059604645 C24.43000030517578,7.71999979019165 13.180000305175781,13.239999771118164 0.05999999865889549,13.300000190734863 C-13.050000190734863,13.359999656677246 -24.360000610351562,7.949999809265137 -29.389999389648438,0.14000000059604645 C-24.43000030517578,-7.71999979019165 -13.180000305175781,-13.229999542236328 -0.05999999865889549,-13.300000190734863 C6.269999980926514,-13.329999923706055 12.180000305175781,-12.079999923706055 17.15999984741211,-9.90999984741211"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,165.58200073242188,300.0989990234375)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M12.527999877929688,4.4629998207092285 C8.126999855041504,16.81800079345703 -0.8069999814033508,25.610000610351562 -9.862000465393066,27.68199920654297 C-15.567000389099121,20.351999282836914 -16.929000854492188,7.892000198364258 -12.527999877929688,-4.4629998207092285 C-8.12600040435791,-16.81800079345703 0.8069999814033508,-25.610000610351562 9.862000465393066,-27.68199920654297 C15.567000389099121,-20.351999282836914 16.93000030517578,-7.892000198364258 12.527999877929688,4.4629998207092285z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,118.46299743652344,304.2799987792969)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M27.93000030517578,9.130000114440918 C20.760000228881836,15.029999732971191 8.34000015258789,16.719999313354492 -4.130000114440918,12.640000343322754 C-16.600000381469727,8.5600004196167 -25.6200008392334,-0.14000000059604645 -27.93000030517578,-9.140000343322754 C-20.75,-15.029999732971191 -8.329999923706055,-16.719999313354492 4.139999866485596,-12.640000343322754 C12.640000343322754,-9.859999656677246 19.540000915527344,-4.929999828338623 23.799999237060547,0.7799999713897705"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,150.44900512695312,239.9010009765625)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M-19.215999603271484,22.339000701904297 C-10.026000022888184,23.638999938964844 1.4539999961853027,18.608999252319336 9.973999977111816,8.638999938964844 C18.493999481201172,-1.3309999704360962 21.673999786376953,-13.451000213623047 18.964000701904297,-22.340999603271484 C9.763999938964844,-23.631000518798828 -1.715999960899353,-18.611000061035156 -10.246000289916992,-8.640999794006348 C-15.736000061035156,-2.2109999656677246 -19.016000747680664,5.109000205993652 -19.9060001373291,11.888999938964844"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,113.46697235107422,245.40501403808594)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M18.535999298095703,23.315000534057617 C18.525999069213867,23.325000762939453 18.525999069213867,23.325000762939453 18.525999069213867,23.334999084472656 C9.276000022888184,24.135000228881836 -1.9240000247955322,18.4950008392334 -9.894000053405762,8.085000038146973 C-17.86400032043457,-2.3350000381469727 -20.384000778198242,-14.614999771118164 -17.194000244140625,-23.334999084472656 C-7.943999767303467,-24.135000228881836 3.25600004196167,-18.4950008392334 11.22599983215332,-8.085000038146973 C13.656000137329102,-4.90500020980835 15.586000442504883,-1.5449999570846558 16.986000061035156,1.8250000476837158"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,134.96397399902344,175.51499938964844)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M13.420000076293945,8.3149995803833 C13.710000038146973,5.09499979019165 13.649999618530273,1.6950000524520874 13.180000305175781,-1.774999976158142 C11.430000305175781,-14.774999618530273 4.510000228881836,-25.225000381469727 -3.9200000762939453,-29.125 C-11.020000457763672,-23.135000228881836 -14.930000305175781,-11.225000381469727 -13.180000305175781,1.774999976158142 C-11.430000305175781,14.765000343322754 -4.510000228881836,25.225000381469727 3.9200000762939453,29.125"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.9999999403953552,0.0002938330580946058,-0.0002938330580946058,0.9999999403953552,172.99168395996094,174.19993591308594)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M-16.339866638183594,-4.757514476776123 C-13.409866333007812,-7.467514514923096 -9.895000457763672,-9.92199993133545 -5.934999942779541,-11.902000427246094 C5.804999828338623,-17.75200080871582 18.344999313354492,-17.892000198364258 26.30500030517578,-13.112000465393066 C25.325000762939453,-3.871999979019165 17.674999237060547,6.047999858856201 5.934999942779541,11.89799976348877 C-5.804999828338623,17.74799919128418 -18.344999313354492,17.898000717163086 -26.30500030517578,13.107999801635742 C-26.295000076293945,13.027999877929688 -26.28499984741211,12.947999954223633 -26.274999618530273,12.868000030517578"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.9999997615814209,-0.0006909345975145698,0.0006909345975145698,0.9999997615814209,202.82118225097656,116.03379821777344)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M8.909000396728516,9.890999794006348 C-0.8349999785423279,18.670000076293945 -12.890000343322754,22.136999130249023 -21.840999603271484,19.656999588012695 C-23.378000259399414,10.496000289916992 -18.63800048828125,-1.090999960899353 -8.894000053405762,-9.869999885559082 C0.8500000238418579,-18.64900016784668 12.888999938964844,-22.139999389648438 21.84000015258789,-19.65999984741211 C23.37700080871582,-10.49899959564209 18.652999877929688,1.1119999885559082 8.909000396728516,9.890999794006348z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_28_2)",
    style: {
      mixBlendMode: "multiply",
      display: "block"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,465.08587646484375,-35.000091552734375)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,206.21299743652344,335.4960021972656)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M13.253000259399414,-1.1019999980926514 C14.34000015258789,11.968999862670898 9.829000473022461,23.663999557495117 2.434999942779541,29.285999298095703 C-5.785999774932861,24.961999893188477 -12.166000366210938,14.17300033569336 -13.253000259399414,1.1019999980926514 C-14.34000015258789,-11.968999862670898 -9.829000473022461,-23.663999557495117 -2.434999942779541,-29.285999298095703 C5.785999774932861,-24.961999893188477 12.166000366210938,-14.17300033569336 13.253000259399414,-1.1019999980926514z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,165.58200073242188,300.0989990234375)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M12.527999877929688,4.4629998207092285 C8.126999855041504,16.81800079345703 -0.8069999814033508,25.610000610351562 -9.862000465393066,27.68199920654297 C-15.567000389099121,20.351999282836914 -16.929000854492188,7.892000198364258 -12.527999877929688,-4.4629998207092285 C-8.12600040435791,-16.81800079345703 0.8069999814033508,-25.610000610351562 9.862000465393066,-27.68199920654297 C15.567000389099121,-20.351999282836914 16.93000030517578,-7.892000198364258 12.527999877929688,4.4629998207092285z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,150.44900512695312,239.9010009765625)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M-19.215999603271484,22.339000701904297 C-10.026000022888184,23.638999938964844 1.4539999961853027,18.608999252319336 9.973999977111816,8.638999938964844 C18.493999481201172,-1.3309999704360962 21.673999786376953,-13.451000213623047 18.964000701904297,-22.340999603271484 C9.763999938964844,-23.631000518798828 -1.715999960899353,-18.611000061035156 -10.246000289916992,-8.640999794006348 C-15.736000061035156,-2.2109999656677246 -19.016000747680664,5.109000205993652 -19.9060001373291,11.888999938964844"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.9999999403953552,0.0002938330580946058,-0.0002938330580946058,0.9999999403953552,172.99168395996094,174.19993591308594)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M-16.339866638183594,-4.757514476776123 C-13.409866333007812,-7.467514514923096 -9.895000457763672,-9.92199993133545 -5.934999942779541,-11.902000427246094 C5.804999828338623,-17.75200080871582 18.344999313354492,-17.892000198364258 26.30500030517578,-13.112000465393066 C25.325000762939453,-3.871999979019165 17.674999237060547,6.047999858856201 5.934999942779541,11.89799976348877 C-5.804999828338623,17.74799919128418 -18.344999313354492,17.898000717163086 -26.30500030517578,13.107999801635742 C-26.295000076293945,13.027999877929688 -26.28499984741211,12.947999954223633 -26.274999618530273,12.868000030517578"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.9999997615814209,-0.0006909345975145698,0.0006909345975145698,0.9999997615814209,202.82118225097656,116.03379821777344)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M8.909000396728516,9.890999794006348 C-0.8349999785423279,18.670000076293945 -12.890000343322754,22.136999130249023 -21.840999603271484,19.656999588012695 C-23.378000259399414,10.496000289916992 -18.63800048828125,-1.090999960899353 -8.894000053405762,-9.869999885559082 C0.8500000238418579,-18.64900016784668 12.888999938964844,-22.139999389648438 21.84000015258789,-19.65999984741211 C23.37700080871582,-10.49899959564209 18.652999877929688,1.1119999885559082 8.909000396728516,9.890999794006348z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,465.08587646484375,-35.000091552734375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,210.9980010986328,272.9150085449219)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    className: "primary",
    stroke: "rgb(255,198,56)",
    strokeOpacity: 1,
    strokeWidth: 7,
    d: " M-30.0049991607666,-137.2050018310547 C-50.064998626708984,-112.88500213623047 -80.55500030517578,-69.00499725341797 -80.55500030517578,-26.924999237060547 C-80.55500030517578,40.185001373291016 -42.345001220703125,84.23500061035156 8.654999732971191,94.74500274658203 C27.19499969482422,98.56500244140625 44.494998931884766,106.93499755859375 58.994998931884766,119.1050033569336 C58.994998931884766,119.1050033569336 80.55500030517578,137.2050018310547 80.55500030517578,137.2050018310547"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,214.95700073242188,338.8500061035156)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M-9,14.15999984741211 C-9,14.15999984741211 9,14.15999984741211 9,14.15999984741211 C16.81999969482422,14.15999984741211 23.15999984741211,7.820000171661377 23.15999984741211,0 C23.15999984741211,0 23.15999984741211,0 23.15999984741211,0 C23.15999984741211,-7.820000171661377 16.81999969482422,-14.15999984741211 9,-14.15999984741211 C9,-14.15999984741211 -9,-14.15999984741211 -9,-14.15999984741211 C-16.81999969482422,-14.15999984741211 -23.15999984741211,-7.820000171661377 -23.15999984741211,0 C-23.15999984741211,0 -23.15999984741211,0 -23.15999984741211,0 C-23.15999984741211,7.820000171661377 -16.81999969482422,14.15999984741211 -9,14.15999984741211z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,203.8769989013672,338.8500061035156)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "rgb(255,198,56)",
    fillOpacity: 1,
    d: " M-2.0799999237060547,0 C-2.0799999237060547,-7.820000171661377 4.260000228881836,-14.15999984741211 12.079999923706055,-14.15999984741211 C12.079999923706055,-14.15999984741211 2.0799999237060547,-14.15999984741211 2.0799999237060547,-14.15999984741211 C-5.739999771118164,-14.15999984741211 -12.079999923706055,-7.820000171661377 -12.079999923706055,0 C-12.079999923706055,7.820000171661377 -5.739999771118164,14.15999984741211 2.0799999237060547,14.15999984741211 C2.0799999237060547,14.15999984741211 12.079999923706055,14.15999984741211 12.079999923706055,14.15999984741211 C4.260000228881836,14.15999984741211 -2.0799999237060547,7.820000171661377 -2.0799999237060547,0z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaurel);
export default __webpack_public_path__ + "static/media/Laurel.e3a767f8313df819a3934ac4131683e5.svg";
export { ForwardRef as ReactComponent };